import React, { Component } from 'react'
import { connect } from 'react-redux'
import DatePicker from "react-datepicker";
import { addNewDefect } from '../../../../store/actions/sketchActions';
import Loader from 'react-loader-spinner';

import { get } from 'lodash'

class NewDefect extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: "",

            descriptionCount: 0,
            description: "",

            deadlineToShow: new Date(),
            deadlineInMillis: new Date().getTime(),
            isDeadlineComplete: false,

            selectedTagIds: [],
            snagPictures: [],
        }
    }

    /// README: TITLE AND DESCRIPTION STATE CHANGES
    handleChange = (e) => {
        switch (e.target.id) {
            case "newTitle": {
                this.setState({
                    title: e.target.value,
                })
                break;
            }
            case "newDescription": {
                this.setState({
                    descriptionCount: e.target.value.length,
                    description: e.target.value,
                })
                break;
            }
            case "isNewDeadlineComplete": {
                const isDeadlineComplete = this.state.isDeadlineComplete;
                this.setState({
                    isDeadlineComplete: !isDeadlineComplete,
                })
                break;
            }
            default:
        }
    }

    /// README: UPDATE DATE AND MILLIS
    handleDeadlineChange = (date) => {
        this.setState({
            deadlineToShow: date,
            deadlineInMillis: date.getTime(),
        });
    }

    /// README: HANDLE TAG SELECTION AND REMOVAL
    handleTagSelect = (tagMap) => {
        const { selectedTagIds } = this.state;

        var newSelectedTagIds = selectedTagIds;

        if (selectedTagIds.indexOf(tagMap.tagid) === -1) {
            newSelectedTagIds = [...newSelectedTagIds, tagMap.tagid];
        } else {
            newSelectedTagIds = newSelectedTagIds.filter(stagid => stagid !== tagMap.tagid);
        }

        this.setState({
            selectedTagIds: newSelectedTagIds,
        })
    }

    /// README: SORTING TAGS BY NAME
    compare(a, b) {
        if ('name' in a && 'name' in b) {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
        }
        return 0;
    }


    /// README: HANDLING PICTURE ADDITIONS
    onPictureAddHandler = (e) => {
        if (this.maxSelectFile(e) && this.checkMimeType(e) && this.checkFileSize(e)) {
            var snagPictures = this.removeRedundantFilenames(e.target.files);
            var existingSnagPictures = this.state.snagPictures
            this.setState(() => ({ snagPictures: [...snagPictures, ...existingSnagPictures], }));
        }
    }

    deleteThisPicture = (file, i) => {
        const { snagPictures } = this.state;
        const filteredSnagPictures = [...snagPictures].filter((eachPicture) => eachPicture.name !== file.name);
        this.setState(() => ({ snagPictures: [...filteredSnagPictures], }));
        console.log(snagPictures);
        console.log(file.name);
    }


    removeRedundantFilenames = (files) => {
        const { snagPictures } = this.state;
        // check if files are already not in state
        var filteredFiles = [...files].filter(s => snagPictures.every(t => {
            return s.name !== t.name
        }));

        return filteredFiles;
    }

    maxSelectFile = (e) => {
        let files = e.target.files
        if (files.length > 20) {
            const msg = 'Only 20 images can be attached with defect'
            e.target.value = null
            alert(msg)
            return false;
        }
        return true;
    }

    checkFileSize = (e) => {
        let files = e.target.files
        let size = 5242880;
        let err = "";
        for (var x = 0; x < files.length; x++) {
            if (files[x].size > size) {
                err = 'File is too large, please pick a smaller file\n';
                alert(err);
            }
        };
        if (err !== '') {
            e.target.value = null
            return false
        }
        return true;
    }

    checkMimeType = (e) => {
        let files = e.target.files
        let err = ''
        const types = ['image/jpeg', 'image/png', 'image/JPEG', 'image/PNG']
        for (var x = 0; x < files.length; x++) {
            if (!types.includes(files[x].type)) {
                err = 'File is not in a supported format\n';
                alert(err);
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            return false;
        }
        return true;
    }

    /// README: SUBMITTING THE FORM
    handleSubmit = (e) => {
        e.preventDefault();
        const { selectedTagIds, snagPictures, title, description, deadlineInMillis, isDeadlineComplete } = this.state;
        const { downX, downY, project, floor, isElevationMap, commons } = this.props;
        const { floorMeta } = project;
        const { elevationMeta } = floor;


        if (selectedTagIds.length < 1) {
            alert(`Please attach at least one ${commons.tagCategory} to continue`);
        } else {
            if (isElevationMap === false) {
                const isFirstOrder = true;
                this.props.addNewDefect(
                    floorMeta.proid,
                    floorMeta.floorid,
                    [downX, downY],
                    selectedTagIds,
                    snagPictures,
                    title,
                    description,
                    deadlineInMillis,
                    isDeadlineComplete,
                    isFirstOrder,
                );
            } else if (isElevationMap === true) {
                const isFirstOrder = false;
                this.props.addNewDefect(
                    elevationMeta.proid,
                    elevationMeta.floorid,
                    [downX, downY],
                    selectedTagIds,
                    snagPictures,
                    title,
                    description,
                    deadlineInMillis,
                    isDeadlineComplete,
                    isFirstOrder,
                );
            }
        }
    }

    /// README: RENDER THE UI
    render() {
        const { title, descriptionCount, description, deadlineToShow,
            selectedTagIds,
            snagPictures,
        } = this.state;

        const { mut, formLabelStyle, themeColors, snagDetail, defectMarker, defectMarkers, commons } = this.props;
        const markerTitle = mut.text["0"];

        /// this is placed to pause snagDetail related stuff while snagDetail is not available
        if (!snagDetail) {
            return <React.Fragment />
        }

        const relevantSubmitComponent =
            <button className="btn btn-dark btn-sm">Add this {markerTitle}</button>

        return (
            <React.Fragment>
                <form onSubmit={this.handleSubmit}>
                    {/* Title and description */}
                    <div className="form-group text-left">

                        <label htmlFor="inputText" style={formLabelStyle}>Title *</label>
                        <input type="text" className="form-control form-control-sm" id="newTitle" onChange={this.handleChange} required defaultValue={title} />
                    </div>
                    <div className="form-group text-left">
                        <label htmlFor="inputText" style={formLabelStyle}>Description *</label>
                        <span className="ml-3" style={{ fontSize: "12px", color: "GrayText" }}>({descriptionCount}/200)</span>
                        <textarea maxLength="200" rows="3" className="form-control form-control-sm" id="newDescription" onChange={this.handleChange} required defaultValue={description} />
                    </div>
                    <hr />
                    {/* Pick a deadline component */}
                    <div className="form-group text-left">
                        <label style={formLabelStyle}>Select deadline *</label>
                        <DatePicker
                            selected={deadlineToShow}
                            onChange={(date) => this.handleDeadlineChange(date)}
                            dateFormat="MMMM eeee d, yyyy h:mm aa"
                            inline={true}
                            title="Select deadline"
                            disabledKeyboardNavigation
                        />
                        <div className="custom-control custom-checkbox mt-3">
                            <input type="checkbox" className="custom-control-input ml-3" id="isNewDeadlineComplete" name="isNewDeadlineCompleteBox" onChange={this.handleChange} />
                            <label className="custom-control-label" htmlFor="isNewDeadlineComplete" style={formLabelStyle}>Task completed?</label>
                        </div>
                    </div>
                    <hr />
                    {/* Tag attach and removal component */}
                    <div className="form-group text-left">
                        <label style={formLabelStyle}>Attach {commons.tagCategories} *</label>
                        <p style={{ fontSize: "12px", color: "GrayText" }}>Tap on the {commons.tagCategories} to attach or remove it from your selection</p>
                        <div className="row row-cols mx-3">
                            {'allTagsMap' in snagDetail ? Object.keys(snagDetail.allTagsMap).length > 1 ? Object.values(snagDetail.allTagsMap).sort(this.compare).filter(val => (val.tagid !== "elevation") && (!val.name.includes('[DELETED]'))).map((val, i) => {
                                var pillBackgroundColor = selectedTagIds.indexOf(val.tagid) > -1 ? themeColors.themeColor : themeColors.themeColorTrans;
                                var pillTextColor = selectedTagIds.indexOf(val.tagid) > -1 ? "whitesmoke" : themeColors.themeColor;
                                return (
                                    <div key={val.tagid} onClick={() => this.handleTagSelect(val)}>
                                        <span className="badge badge-pill mx-1 px-3" role="button" style={{ backgroundColor: `${pillBackgroundColor}`, color: `${pillTextColor}`, textAlign: "end", fontSize: "12px" }}>{val.name}</span>
                                    </div>
                                );
                            }) : `No ${commons.tagCategories} found` : `No ${commons.tagCategories} found`}
                        </div>
                        <br />
                        <span className="badge badge-dark mx-3">{selectedTagIds.length} {commons.tagCategories} attached</span>
                        <div className="row row-cols mx-3">
                            {selectedTagIds.map((val, i) => (
                                <div key={val}>
                                    <span className="mx-2" style={{ fontSize: "12px", fontWeight: "bold" }}>{snagDetail.allTagsMap[val]['name']}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <hr />
                    {/* File upload button */}
                    <div className="form-group text-left">
                        <label style={formLabelStyle}>Attach pictures</label>
                        <br />
                        <label htmlFor="newDefectFiles">
                            <span role="button" className="btn btn-outline-dark btn-sm" >
                                Select pictures
                            </span>
                        </label>
                        <br />
                        <input type="file" className="file" id="newDefectFiles" multiple onChange={this.onPictureAddHandler} style={{ fontWeight: "bold", fontSize: "12px", display: "none" }} />
                    </div>
                    <div style={{ maxHeight: "160px", overflow: "hidden", overflowY: "auto" }}>
                        <ul className="list-group align-items-start list-group-flush">
                            {snagPictures.map((fileName, i) => (
                                <li style={{ fontSize: "13px" }} className="list-group-item py-2 border-0" ng-repeat="i in filters" key={i}>
                                    <b>{i + 1}. </b>{`${fileName.name} `} <a href='#!' className='ml-1' onClick={() => { this.deleteThisPicture(fileName, i) }}>(remove)</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <br />
                    <hr />
                    {relevantSubmitComponent}
                    <br />
                    <br />
                </form>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        floorMarkers: state.firestore.data.FloorMarkers,
        mut: state.marker,
        formLabelStyle: state.appControl.formLabelStyle,
        floor: state.floor,
        sketch: state.sketch,

        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addNewDefect: (proid, floorid, coordinates, selectedTagIds, selectedSnagPictures, title, description, deadline, isDeadlineComplete, isFirstOrder) => dispatch(addNewDefect(proid, floorid, coordinates, selectedTagIds, selectedSnagPictures, title, description, deadline, isDeadlineComplete, isFirstOrder)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewDefect)
